import React, { Component } from 'react';
import TimeAgo from 'react-timeago';
import { Link } from 'react-router-dom';
import TextEllipsis from 'react-text-ellipsis';
import axios from 'axios';
import Web3 from 'web3';
import About from './About';

import './css/App.css';

//var api = require('etherscan-api').init('YourApiKey');

class Posts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      posts: []
    }

    this._processText = this._processText.bind(this);
  }

  componentDidMount() {
    this._load();
  }

  render() {
    const posts = this.state.posts.map((post) => {
      return <div className="post" key={post.hash}>
              <Link className="shorten transaction" to={"/posts/"+post.hash}>{post.hash_str}</Link>
              <div className="from">&#10551; <strong>FROM</strong> <a href={"https://etherscan.io/address/"+post.from} className="shorten" target="_blank" rel="noopener noreferrer">{post.from_str}</a> <span className="red">//</span> <span className="grey"><TimeAgo date={post.timestamp*1000} /></span></div>

              <div className="post-text">
                <TextEllipsis
                  lines={5}
                  tag={'span'}
                  >
                  {post.text}
                </TextEllipsis>
              </div>

              <Link className="view-full" to={"/posts/"+post.hash} rel="noopener noreferrer">View full post</Link>
            </div>;
    });
    return (
      <div className="subpage">

        <h1 className="fix"><Link to="/">0xINFINITY</Link></h1>


        <div className="subpage-inner">
          <div className="posts">
            <h2>// Last 25 Posts / <a href={"https://etherscan.io/address/"+window.to}>View All</a></h2>
            {this.state.posts.length > 0 ? posts : <div className="post">Loading...</div>}

          </div>
          <About home={true}/>
        </div>
      </div>
    );
  }

  _load() {
    var posts = [];
    var self = this;

      axios.get('https://api.etherscan.io/api?module=account&action=txlist&address='+window.to+'&sort=desc&apikey=EF74J5VZT35PIZDFWIR49EPNZNMNSH79CF')
        .then(function (response) {
          //console.log(response);

          const tx = response.data;

          for(let x = 0 ; x < tx.result.length ; x++) {
            var obj = {
              timestamp: tx.result[x].timeStamp,
              from: tx.result[x].from,
              from_str: self._shorten(tx.result[x].from),
              hash: tx.result[x].hash,
              hash_str: self._shorten(tx.result[x].hash),
              text: self._processText(Web3.utils.hexToUtf8(tx.result[x].input))
            };
            posts.push(obj);
          }

          self.setState({posts})
        })
        .catch(function (error) {
          console.log(error);
        });


    //});
  }

  _processText(text) {
    text = text.replace(/^\n|\n$/g, '');
    return text;
  }

  _shorten(str) {
    if(window.innerWidth < 600) {
      str = str.substr(0, 26) + "...";
    }

    return str;
  }
}

export default Posts;



// WEBPACK FOOTER //
// ./src/Posts.js